import { useFormat } from 'vivat';

import useInvoiceStatus from '@/useInvoiceStatus';
import usePayment from '@/usePayment';

const { invoiceStatusClassMap, translate } = useInvoiceStatus();
const { translate: paymentMethodTranslate } = usePayment();

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _selectorControls: {
      width: '2rem',
      // name: 'SELECT',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return invoiceStatusClassMap(val);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val);
      },
    },
    createdAt: {
      name: 'สร้างเมื่อ',
      width: '12rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    code: {
      name: 'เลขที่รายการวางบิล',
      width: '10rem',
    },
    'deliveries.length': {
      name: 'จำนวนรายการ',
      width: '8rem',
      class: 'text-center',
    },
    'debtor.name': {
      name: 'ลูกหนี้',
      width: '16rem',
    },
    amount: {
      name: 'จำนวนเงิน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    discount: {
      name: 'ส่วนลด',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.number(val).currency(),
    },
    type: {
      name: 'ประเภท',
      width: '8rem',
      class: 'text-center',
      filter: (val: string) => paymentMethodTranslate(val),
    },
    dueDate: {
      name: 'กำหนดชำระ',
      width: '8rem',
      class: 'text-center',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    date: {
      name: 'ได้รับเงินวันที่',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string, row: any) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    'createdBy.name': {
      name: 'ผู้ทำรายการ',
      width: '10rem',
      class: 'text-right',
    },
  },
  sortable: [
    'status',
    'createdAt',
    'code',
    'deliveries.length',
    'debtor.name',
    'amount',
    'type',
    'dueDate',
    'date',
    'createdBy',
  ],
};
